import type { FC, PropsWithChildren } from "react";
import { createContext, useCallback, useContext } from "react";
import type { LabelKey, LabelsMap } from "~/lib/prismic";

export type PT = {
  (key: keyof LabelsMap, replace?: Record<string, string>, nullish?: false): string;
  (key: keyof LabelsMap, replace: Record<string, string> | undefined, nullish: true): string | null;
};
export const PrismicLabelsCtx = createContext<{
  $pt: PT;
  $map: LabelsMap;
}>({
  $pt: () => "",
  $map: {},
});

export const PrismicLabelsCtxProvider: FC<
  PropsWithChildren<{
    pt: LabelsMap;
  }>
> = ({ children, pt }) => {
  const $pt = useCallback(
    ((key: LabelKey, replace: Record<string, string> = {}, nullish = false) => {
      if (!pt[key]) return nullish ? null : `${key}`;
      return (
        pt[key]?.replace(/{([^}]+)}/g, (ori, k) => replace[k] || ori) ||
        `${key}`
      );
    }) as PT,
    [pt]
  );

  return (
    <PrismicLabelsCtx.Provider value={{ $pt, $map: pt }}>
      {children}
    </PrismicLabelsCtx.Provider>
  );
};

export const usePrismicLabels = () => useContext(PrismicLabelsCtx);
